<template>
  <div class="productPackMembers">
    <div class="productPackMembers__title">Elementy zestawu ({{ members.length }})</div>
    <div class="productPackMembers__list">
      <nuxt-link
        v-for="(item, index) in members"
        :key="item.slug"
        class="productPackMembers__item"
        :to="localePath({ name: 'product-slug', params: { slug: item.slug } })"
        @click.native="gTagProductClick(item)"
        :class="{
          'productPackMembers__item--hide': index > collapseCount - 1 && !isCollapse,
        }"
      >
        <span>{{ item.quantity }}x</span> {{ item.name }}
      </nuxt-link>
    </div>
    <button
      v-if="members.length > collapseCount && !isCollapse"
      class="productDetails__toggle"
      @click="toggle"
    >
      <span class="productDetails__toggleIcon" />
      <span class="productDetails__toggleText">zobacz wszystkie produkty</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ProductPackMembers',
  props: {
    members: {
      type: Array,
      default: () => {},
    },
    product: {
      type: Object,
      default: () => {},
    },
    collapseCount: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      hoverVariant: [],
      isCollapse: false,
    };
  },
  methods: {
    toggle() {
      this.isCollapse = this.isCollapse !== true;
    },
    gTagProductClick(item) {
      const categories = this.product.category.namesInPath.reduce((acc, curr, index) => {
        acc['category' + (index === 0 ? '' : index + 1)] = curr;
        return acc;
      }, {});

      this.$gtm.push({ ecommerce: null });
      this.$gtm.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: '',
          item_list_name: '',
          items: [
            {
              item_id: item.id,
              item_name: item.name,
              discount: 0,
              brand: this.product.brand ? this.product.brand.name : '',
              ...categories,
              item_list_id: '',
              item_list_name: '',
              promotion_id: item?.promotion?.id ?? '',
              promotion_name: item?.promotion?.name ?? '',
              price: item.priceGross,
              variant: '',
              quantity: 1,
            },
          ],
        },
      });
    },
  },
};
</script>

<style lang="scss">
.productPackMembers {
  margin-bottom: 2rem;

  &__title {
    color: $cMainNeutral;
    font-size: 2rem;
    line-height: 2.4rem;
    font-weight: 600;
    margin-bottom: 0.8rem;
  }

  &__item {
    display: block;
    font-size: 1.4rem;
    line-height: 2.4rem;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }

    span {
      color: $cAddDark02;
    }

    &--hide {
      display: none;
    }
  }
}
</style>
